import React, { createContext, useState } from "react";

// Crea un contexto de React para compartir datos entre componentes
const Context = createContext();

// Define un proveedor de contexto que encapsula a los componentes hijos
export const CartContextProvider = ({ children }) => {
  // Estados locales para el carrito y la lista de deseos
  const [cart, setCart] = useState([]);
  const [wish, setWish] = useState([]);
  const [stock, setStock] = useState();

  // Función para agregar un elemento al carrito
  const addItem = (productToAdd, quantity) => {
    // Crea un nuevo objeto con la cantidad seleccionada y el producto
    const newObj = {
      ...productToAdd,
      quantity,
    };
    // Verifica si el producto ya está en el carrito y actualiza la cantidad
    if (isInCart(newObj.id)) {
      // Utiliza el método map para iterar sobre cada elemento del array cart
      const updatedCart = cart.map((el) => {
        // Verifica si el id del elemento actual coincide con el id del nuevo objeto a agregar (newObj)
        if (el.id === newObj.id) {
          // Si hay coincidencia, incrementa la cantidad del elemento actual con la cantidad del nuevo objeto
          return { ...el, quantity: el.quantity + newObj.quantity };
        }
        // Devuelve el elemento actual sin modificar
        return el;
      });

      // Actualiza el estado con el nuevo array
      setCart(updatedCart);
    } else {
      // Si el producto no está en el carrito, agrégalo
      setCart([...cart, newObj]);
    }
    localStorage.setItem("cart", JSON.stringify([...cart, newObj]));
  };

  const isInCart = (id) => {
    return cart.some((el) => el.id === id);
  };
  // Función para obtener el total del carrito
  const getTotal = () => {
    const total = cart.reduce(
      (acc, item) => acc + item.price * item.quantity,
      0
    );
    return total;
  };

  // Función para obtener la cantidad total de productos en el carrito
  const getQuantity = () => {
    let count = 0;

    // forEach: se utiliza cuando solo necesitas realizar acciones (como actualizar una variable) en cada elemento del array, pero no necesitas crear un nuevo array.
    // map: Se utiliza cuando deseas crear un nuevo array basado en la transformación de cada elemento del array original.
    cart.forEach((prod) => {
      count = count + prod.quantity;
    });
    return count;
  };
  // Función para verificar si un producto está en el carrito

  // Función para remover un producto del carrito
  const removeItem = (id) => {
    const deleteItem = cart.filter((el) => el.id !== id);
    setCart([...deleteItem]);
  };

  // Función para vaciar el carrito
  const clear = () => {
    setCart([]);
  };

  // Función para obtener un producto específico en el carrito
  const productInCart = (productId) => {
    return cart.find((item) => item.id === productId);
  };

  // Función para obtener la cantidad actual de un producto en el carrito
  const currentQuantity = (productId) => {
    // sin firebase parsear el id
    // const product = productInCart(parseInt(productId));

    // con firebase no
    const product = productInCart(productId);

    return product ? product.quantity : 0;
  };

  // Función para decrementar la cantidad de un producto en el carrito
  const decrementItem = (productId) => {
    const updatedCart = cart.map((el) => {
      if (el.id === productId) {
        // Decrementa la cantidad, asegurándose de que no sea menor que 1
        const newQuantity = Math.max(el.quantity - 1, 1);
        return { ...el, quantity: newQuantity };
      }
      return el;
    });

    setCart(updatedCart);
  };

  // Función para incrementar la cantidad de un producto en el carrito
  const incrementItem = (productId) => {
    const updatedCart = cart.map((el) => {
      if (el.id === productId) {
        // Incrementa la cantidad, asegurándose de que no supere el stock disponible
        const newQuantity = Math.min(el.quantity + 1, stock);
        return { ...el, quantity: newQuantity };
      }
      return el;
    });

    setCart(updatedCart);
  };

  // Función para agregar un elemento a la lista de deseos
  const wishItem = (desiredProduct, quantity) => {
    const newObj = {
      ...desiredProduct,
      quantity,
    };
    // Verifica si el producto ya está en la lista de deseos y la vacía si es así
    if (wished(newObj.id)) {
      setWish([]);
    } else {
      // Si el producto no está en la lista de deseos, agrégalo
      setWish([...wish, newObj]);
    }
  };

  // Función para verificar si un producto está en la lista de deseos
  const wished = (id) => {
    return wish.some((el) => el.id === id);
  };

  // Función para vaciar la lista de deseos
  const clearWished = () => {
    setWish([]);
  };

  // Función para remover un producto de la lista de deseos
  const removeWished = (id) => {
    const deleteWished = wish.filter((el) => el.id !== id);
    setWish([...deleteWished]);
  };
  // Proporciona el contexto y sus funciones como valor para los componentes hijos
  return (
    //Cuando creas un contexto con createContext en React, obtienes un objeto que tiene un componente llamado Provider y un componente llamado Consumer (con el hook useContext, esto quedo simplificado).
    <Context.Provider
      value={{
        cart,
        setCart,
        addItem,
        removeItem,
        clear,
        getQuantity,
        getTotal,
        wishItem,
        removeWished,
        currentQuantity,
        setStock,
        incrementItem,
        decrementItem,
      }}
    >
      {children}
    </Context.Provider>
  );
};

// Exporta el contexto para ser utilizado en otros componentes
export default Context;
